import './App.css';
import Header from './Components/Header';
import Works from './Components/Works';
import About from './Components/About';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import AmazonClone from './Components/AmazonClone';
import CovidTracker from './Components/CovidTracker';
import EcommerceWebsite from './Components/EcommerceWebsite';
import MakeupArtistWebsite from './Components/MakeupArtistWebsite'
import MusicPlayer from './Components/MusicPlayer'
import ShoppingCart from './Components/ShoppingCart'
import SortingVisualizer from './Components/SortingVisualizer';
import TextAnalyzer from './Components/TextAnalyzer'
import ToDoList from './Components/ToDoList'
import TravelImageGallery from './Components/TravelImageGallery'
import WeatherApp from './Components/WeatherApp'


function App() {
  return (
    <Router>
      <div className="app">
        <div className="app__left">
          <Header />
        </div>
        <Switch>
          <div className="app__right">
            <Route exact path="/">
              <Works />
            </Route>
            <Route exact path="/about">
              <About />
            </Route>
            <Route path="/sorting-visualizer">
              <SortingVisualizer />
            </Route>
            <Route exact path="/travel-image-gallery">
              <TravelImageGallery />
            </Route>
            <Route exact path="/text-analyzer">
              <TextAnalyzer />
            </Route>
            <Route exact path="/covid19-tracker">
              <CovidTracker />
            </Route>
            <Route exact path="/ecommerce-website">
              <EcommerceWebsite />
            </Route>
            <Route exact path="/shopping-cart">
              <ShoppingCart />
            </Route>
            <Route exact path="/to-do-list">
              <ToDoList />
            </Route>
            <Route exact path="/amazon-clone">
              <AmazonClone />
            </Route>
            <Route exact path="/weather-app">
              <WeatherApp />
            </Route>
            <Route exact path="/makeup-artist-website">
              <MakeupArtistWebsite />
            </Route>
            <Route exact path="/music-player">
              <MusicPlayer />
            </Route>
          </div>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
